<template>
    <UserActivityTile @click="tileClicked" :userActivity="userActivity">


        <template v-slot:title>{{ userActivity.body.payoutName }}</template>
        <template v-slot:subtitle>{{ userActivity.username }}</template>

        
        <template v-slot:append-item-right>
            <UserActivityMoneyChip>
                {{ abbreviateNumber(userActivity.body.currencyAmount) }} {{ userActivity.body.currency }}
            </UserActivityMoneyChip>
        </template>


    </UserActivityTile>
</template>



<script lang="ts" setup>

import { PropType } from 'vue';
import { useRouter } from 'vue-router';

import { abbreviateNumber } from '@/utils/GlobalMethods';
import { IPayoutUserActivity } from '@/interfaces/UserActivity/IPayoutUserActivity';
import UserActivityTile from '@/components/Tiles/UserActivity/UserActivityTile.vue';
import UserActivityMoneyChip from '@/components/UserActivity/UserActivityTileElements/UserActivityMoneyChip.vue';

const props = defineProps({
    userActivity: {
        type: Object as PropType<IPayoutUserActivity>,
        required: true,
    },
});

const router = useRouter();

const tileClicked = () => {
    router.push('/rewards');
}

</script>
